import { brokerUserModelNormalizer } from '@energy-stacks/broker/feature-users-data';
import { useLogin } from '@energy-stacks/user-access';

export const BrokerUserLogin = () => {
  useLogin(brokerUserModelNormalizer);
  return null;
};
